/**
 * Canonical account-area URLs (single source of truth for nav + deep links).
 * Wishlist lives under the protected account shell — same route for every authenticated role.
 */
export const ACCOUNT_WISHLIST_PATH = '/account/wishlist' as const;
